import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import {
  KeyboardDatePicker
} from '@material-ui/pickers';

import {
  Box,
  Link,
  Card,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  makeStyles,
  Grid,
  colors,
  Avatar,
  Icon,
  Typography,
  Button,
  TextField,
  InputAdornment,
  SvgIcon,
  TablePagination,
  Paper,
  FormControl
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';
import Add from '@material-ui/icons/AddCircleOutline';

import Pager from 'src/utils/Pager';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  iconoperation: {
    width: 45,
    height: 45
  },
  baroperation: {
    width: '100%',
    minHeight: 65
  }
}));

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const defaultDependencies = {
  loaded: false
}

const Toolbar = ({ icon, item, resultset, resultModes, vision, visions, selectedMode, openCreation, changeFilter }) => {

  const classes = useStyles();

  const [startDateTime, setStartDateTime] = useState(defaultStartDateTime);
  const [endDateTime, setEndDateTime] = useState(defaultEndDateTime);
  const [keyword, setKeyword] = useState('');
  const [query, setQuery] = useState(vision);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(10);

  const [dependencies, setDependencies] = useState(defaultDependencies);

  const changeStartDatetime = (value) => {
    setStartDateTime(value);
    setPage(0);
    changeFilter(vision, keyword, page, rows, value, endDateTime);
  }

  const changeEndDatetime = (value) => {
    setEndDateTime(value);
    setPage(0);
    changeFilter(vision, keyword, page, rows, startDateTime, value);
  }

  const changeQuery = (event) => {
    setQuery(event.target.value);
    setPage(0);
    changeFilter(event.target.value, keyword, page, rows, startDateTime, endDateTime);
  }

  const changeKeyword = (event) => {
    setKeyword(event.target.value);
    setPage(0);
    changeFilter(vision, event.target.value, page, rows, startDateTime, endDateTime);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeFilter(vision, keyword, newPage, rows, startDateTime, endDateTime);
  };

  const handleChangeRowsPerPage = (event) => {
    var rowsPerPage = parseInt(event.target.value, 10);
    setPage(0);
    setRows(rowsPerPage);
    changeFilter(vision, keyword, 0, rowsPerPage, startDateTime, endDateTime);
  };

  return (
    <Fragment>
      <Box className={classes.baroperation}>

        <Grid container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item
            md="auto"
            xs="auto">
            <Avatar variant="rounded"
              className={classes.avatar}
            >
              {<Icon className={classes.iconoperation} component={icon} style={{ color: colors.cyan[400] }} ></Icon>}
            </Avatar>

          </Grid>

          <Grid item
            md="auto"
            xs="auto">
            <Typography
              color="primary"
              variant="h5"
            >
              Você esta na área de <b>{<Link color="inherit" href="/mgt/main">MANUTENÇÃO</Link>}</b>. A operação padrão é <b> {localStorage.getItem('company')}</b>
            </Typography>

            <Typography
              color="secondary"
              variant="h4"
            >
              <b>Importação</b>
            </Typography>

          </Grid>
        </Grid>
      </Box>

      <Box>
        <Card>
          <CardContent>
            <Grid container
              fullWidth
              direction="row"
              justify="flex-start"
              alignItems="flex-end"
            >
              <Grid item
                md={12}
                xs={12}>

                <Box mb={2}>
                  <Card>
                    <CardContent>
                      <Grid container
                        fullWidth
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        alignContent="flex-start"
                      >
                        <Grid item
                          xs={12}
                        >
                          <Grid container justify="flex-start" spacing={1}>
                            <Grid item
                              md={4}
                              xs={12}
                            >
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="query">Pesquisa</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Pesquisa"
                                  variant="outlined"
                                  id="query"
                                  name="query"
                                  value={query}
                                  onChange={changeQuery}
                                  inputProps={{
                                    name: 'query',
                                    id: 'query',
                                  }}
                                >

                                  {visions.map((view) => (
                                    <MenuItem key={view.id} value={view}>{view.name}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid item
                              md={2}
                              xs={12}>
                              <KeyboardDatePicker
                                disabled={!query.history}
                                margin="none"
                                cancelLabel="Cancelar"
                                id="startDateTime"
                                name="startDateTime"
                                label="Data Inicial"
                                format="DD/MM/YYYY"
                                value={startDateTime}
                                inputVariant="outlined"
                                onChange={changeStartDatetime}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                            <Grid item
                              md={2}
                              xs={12}>
                              <KeyboardDatePicker
                                disabled={!query.history}
                                margin="none"
                                cancelLabel="Cancelar"
                                id="endDateTime"
                                name="endDateTime"
                                label="Data Final"
                                inputVariant="outlined"
                                format="DD/MM/YYYY"
                                value={endDateTime}
                                onChange={changeEndDatetime}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                          </Grid>

                        </Grid>

                      </Grid>

                    </CardContent>

                  </Card>
                </Box>

              </Grid>

              <Grid item
                md={10}
                xs={12}
              >
                <Grid container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >

                  <Grid item
                    md={10}
                    xs={12}
                  >

                    <TablePagination
                      style={{ minWidth: 295 }}
                      variant="caption"
                      component={Paper}
                      className={classes.pager}
                      page={page}
                      rowsPerPage={rows}
                      count={resultset.count}
                      labelRowsPerPage={(screen.width <= 480) ? "" : "Linhas por página"}
                      labelDisplayedRows={(screen.width <= 480) ? (({ from, to, count }) => `${from}-${to} de ${count}`) : (({ from, to, count }) => `Encontrados: ${count}, Apresentando de: ${from} a ${to}`)}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={Pager}
                    />

                  </Grid>

                </Grid>

              </Grid>

              <Grid item
                md={2}
                xs={12}
              >
                <Grid container
                  direction="row-reverse"
                  justify="baseline"
                  alignItems="flex-start"
                >

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    {(resultModes[selectedMode].create != LEVEL_ACCESS_HIDE) ? (
                      <Box mt={2} >
                        <Button
                          color="secondary"
                          disabled={resultModes[selectedMode].create == LEVEL_ACCESS_DISABLED}
                          size="small"
                          variant="contained"
                          startIcon={<Add />}
                          onClick={() => { openCreation(item) }}>
                          Criar Importação
                        </Button>
                      </Box>
                    ) : ('')}

                  </Grid>

                </Grid>

              </Grid>

            </Grid>

          </CardContent>

        </Card>

      </Box>

    </Fragment>

  );
};


Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
